module.exports = __webpack_public_path__ + "static/media/visa-logo.daf63873.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/visa-logo.svg
 ** module id = 1299
 ** module chunks = 0
 **/